import { App, DIPLOMATEN_CODE } from '@ps20-frontend/frontend-models';
import { Produktlinienname, Selbstbeteiligung } from '@ps20/bff-models';
import { IAppState } from '../../../store/appState';
import { VertragsoptionenVHV } from '../../../store/model/vertragsoptionen.model';

export const selectVertragsoptionen = (state: IAppState): VertragsoptionenVHV =>
  state.vertragsoptionen;
export const selectVertragslaufzeit = (state: IAppState): string =>
  String(state.vertragsoptionen.vertragslaufzeit);
export const selectIsDiplomatengeschaeft = (state: IAppState): boolean =>
  state.vertragsoptionen.selectedKooperation === DIPLOMATEN_CODE;
export const selectIsNeugeschaeft = (state: IAppState): boolean =>
  !state.vertragsoptionen.vorvertragsNummern ||
  state.vertragsoptionen.vorvertragsNummern.length === 0;

export const selectIsErsatzgeschaeft = (state: IAppState): boolean =>
  state.vertragsoptionen.vorvertragsNummern?.length > 0 && !state.vertragsoptionen.beibehalten;

export const selectIsErsatzgeschaeftWithPriorPremium = (state: IAppState): boolean =>
  selectIsErsatzgeschaeft(state) &&
  state.transientState?.relevantVorbelegungdaten?.vorvertragForApp === App.VHV_V2 &&
  state.transientState?.relevantVorbelegungdaten?.produktlinienname === Produktlinienname.PREMIUM;

export const selectZahlweise = (state: IAppState): string =>
  state.vertragsoptionen.zahlungsweise.toLowerCase();

const SELBSTBETEILIGUNG_GT1000 = new Set([
  Selbstbeteiligung.SELBSTBETEILIGUNG_1000,
  Selbstbeteiligung.SELBSTBETEILIGUNG_2000,
  Selbstbeteiligung.SELBSTBETEILIGUNG_5000,
  Selbstbeteiligung.SELBSTBETEILIGUNG_10000,
]);

export const selectIsSelbstbeteiligungGt1000 = (state: IAppState): boolean =>
  SELBSTBETEILIGUNG_GT1000.has(state.vertragsoptionen?.selbstbeteiligung);

export const selectIsWohnflaecheUnter80 = (state: IAppState): boolean =>
  state.versObjekt?.wohnflaeche < 80;

const SELBSTBETEILIGUNG_GTE2000 = new Set([
  Selbstbeteiligung.SELBSTBETEILIGUNG_2000,
  Selbstbeteiligung.SELBSTBETEILIGUNG_5000,
  Selbstbeteiligung.SELBSTBETEILIGUNG_10000,
]);

export const selectIsSelbstbeteiligungGte2000 = (state: IAppState): boolean =>
  SELBSTBETEILIGUNG_GTE2000.has(state.vertragsoptionen?.selbstbeteiligung);

export type SelectVertragsoptionenReturnType = ReturnType<typeof selectVertragsoptionen>;
